<div *ngIf="loading" class="loader-overlay">
  <div class="loader"></div>
</div>
     <div class="container-fluid px-4">

        <div class="card mt-4">

            <div class="card-header">
                <h1 class=""style="font-size:22px" >顧客一覧</h1>
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <!-- Left: Items per page -->
                    <div class="d-flex align-items-center">
                        <label class="mr-2 mb-0">表示件数</label>
                        <select class="custom-select w-auto" style="margin-left: 5px;" (change)="onLimitChange($event)">
                            <option [selected]="limit === 10" value="10">10</option>
                            <option [selected]="limit === 25" value="25">25</option>
                            <option [selected]="limit === 50" value="50">50</option>
                            <option [selected]="limit === 100" value="100">100</option>
                        </select>
                        <span class="ml-1" style="margin: 10px;">件</span>
                        
                    </div>

                    <!-- Right: Search box with icon inside -->
                    <div class="position-relative" style="width: 250px;">
                        <i class="fas fa-search search-icon"></i>
                        <input type="text" class="form-control pl-5"name="search_field" placeholder="検索" [(ngModel)]="search_field" maxlength="35" (keyup.enter)="doList()">
                    </div>
                </div>



                <div class="table-responsive text-nowrap">
                    <table id="completedOrderDataTable" class="table" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{japaneseLabel['personalId']}}</th>
                                <th>{{japaneseLabel['customerName']}}</th>
                                <th>{{japaneseLabel['telePhoneNumber']}}</th>
                                <th>{{japaneseLabel['dateOfBirth']}}</th>
                                <th>{{japaneseLabel['numberOfRegister']}}</th>
                                <th>{{japaneseLabel['action']}}</th>                               

                            </tr>
                        </thead>
                        <tbody class="table-border-bottom-0">                                                
                            
                            <tr *ngFor="let customer of customerList;">
                                <td>{{customer.serial_no}}</td>
                                <td>{{customer.first_name}} {{customer.last_name}}</td>
                                <td>{{customer.phone_number}}</td>
                                <td>{{customer.date_of_birth}}</td>
                                <td>{{customer.orders_count}} 件 </td>
                                <td><button type="button" class="btn custom-btn" [routerLink]="['/dashboard/x-ray-new']" [queryParams]="{ user_id: customer.user_id }" [state]="{ customer: customer }">レントゲン登録 </button></td>                               
                            </tr>
                 
                        </tbody>

                    </table>
                </div>
                <ul class="pagination justify-content-center" *ngIf="totalCount">
                  
                    <!-- Page Numbers -->
                    <li *ngFor="let page of pages" class="page-item" [class.active]="page === currentPage">
                        <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
                        {{ page }}
                        </a>
                    </li>

                    <!-- Next -->
                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                        <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                        <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
                <div class="d-flex justify-content-center" *ngIf="totalCount">
                    {{startIndex}}〜{{endIndex}}件 / {{totalCount}}
                </div>
            </div>
        </div>

    </div>